import { createFileRoute } from "@tanstack/react-router";
import { BlogIndexPage } from "@/components/blog/BlogIndexPage";
import { blogIndexSeo } from "@/lib/blog-seo";

export const Route = createFileRoute("/blog/")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => blogIndexSeo(loaderData?.href ?? "/blog"),
  component: BlogIndexPage,
});
